export const REQUEST_SUPPLIERS = 'REQUEST_SUPPLIERS'
export const REQUEST_SUPPLIERS_SUCCESS = 'REQUEST_SUPPLIERS_SUCCESS'
export const REQUEST_SUPPLIERS_FAILURE = 'REQUEST_SUPPLIERS_FAILURE'

export const requestSuppliers = formdata => ({
  type: REQUEST_SUPPLIERS,
  formdata
})

export const fetchSuppliers = formdata => dispatch => {
  dispatch(requestSuppliers(formdata))
     /*   var method='POST';
        const defaults = {
            method,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        }
        if (formdata === Object(formdata)) {
            formdata = JSON.stringify(formdata)
        } else {
            throw new Error(`XHR invalid, check ${method} `)
        }
        var params = {};
        if(formdata) {
            defaults.body = formdata
        }

        const paramsObj = {...defaults, headers: {...params, ...defaults.headers}};
                  
        var url="suppliers_json.php";
        return fetch(url, paramsObj)

        */
        const searchParams = Object.keys(formdata).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(formdata[key]);
          }).join('&');
  var url="suppliers_json.php";

          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: searchParams
          })
            .then(response => response.json())
            .then(json => dispatch(fetchSuppliersSuccess(formdata, json)))
        
 
}

export function fetchSuppliersSuccess(formdata, json) {
    if(json.status) {
        if(window.PubSubManager) {
            window.PubSubManager.publish("fetch_suppliers", json.data);
        }
        return {
        type: REQUEST_SUPPLIERS_SUCCESS,
        suppliers: json.data,
        formdata: formdata,
        receivedAt: Date.now(),
        error: null
        };
    } else {
        return {
            type: REQUEST_SUPPLIERS_FAILURE,
            suppliers: [],
            formdata: formdata,
            receivedAt: Date.now(),
            error: json.message
            };
    }
   }

export function fetchSuppliersFailure(error) {
    return {
    type: REQUEST_SUPPLIERS_FAILURE,
    error: error
    };
   }



// WEBPACK FOOTER //
// ./src/actions/suppliers/index.js